export enum MicrositeType {
    Kidney = 0,
    Liver = 1
}